<template>
  <v-layout class="my-0 mb-1" row wrap>
    <v-flex
      xs12
      md12
      sm12
      lg12
    >
      <v-layout
        row
        wrap
        mx-1
      >
        <v-flex
          xs12
          md12
          sm12
          lg12
          py-0
          my-0
          class="label"
        >
          {{ $t('message.bizgainOnboarding.headlines') }}
        </v-flex>
        <v-flex mt-2>
          <v-card class="py-3 px-0 mx-0" :class="{'px-3':$vuetify.breakpoint.xsOnly}">
            <v-layout
              row
              wrap
              mx-0
              justify-space-around
            >
              <v-flex
                xs12
                sm5
                md5
                lg5
              >
                <span class="label">{{ $t('message.bizgainOnboarding.headline1') }} </span>
                <custom-text-field
                  v-model="headline1"
                  :name="'headline1'"
                  :classes="'body-1'"
                  :counter="30"
                  :validation="'required|max:30'"
                  :icon="isShortenFlow ? 'mdi-check' : ''"
                  @input="updateHeadLine1"
                />
              </v-flex>
              <v-flex
                xs12
                sm5
                md5
                lg5
              >
                <span class="label">{{ $t('message.bizgainOnboarding.headline2') }} </span>
                <custom-text-field
                  v-model="headline2"
                  :classes="'body-1'"
                  :counter="30"
                  :validation="'required|max:30'"
                  :name="'headline2'"
                  :icon="isShortenFlow ? 'mdi-check' : ''"
                  @input="updateHeadLine2"
                />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      md12
      sm12
      lg12
      mt-4
    >
      <v-layout row wrap mx-1>
        <v-flex
          xs12
          md12
          sm12
          lg12
          py-0
          my-0
          class="label"
        >
          {{ $t('message.bizgainOnboarding.descriptions') }}
        </v-flex>
        <v-flex
          md12
          sm12
          lg12
          mt-2
        >
          <v-card class="py-3 px-0 mx-0" :class="{'px-3':$vuetify.breakpoint.xsOnly}">
            <v-layout
              row
              wrap
              mx-1
              justify-space-around
            >
              <v-flex
                v-for="(property, i) in ['description1', 'alternativeDescription1']"
                :key="i"
                xs12
                sm5
                md5
                lg5
              >
                <span class="label">{{ $t('message.bizgainOnboarding.option',{n:i+1}) }} </span>
                <description-field :description="{name:property , value: textAd[property] }" :is-single-service-selected="isSingleServiceSelected" @update="updateDescription" />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VCard
} from 'vuetify/lib';
import { mapGetters } from 'vuex';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import DescriptionField from './DescriptionField.vue';

export default {
  components: {
    VLayout,
    VFlex,
    DescriptionField,
    VCard,
    CustomTextField
  },
  data() {
    return {
      isSingleServiceSelected: false,
      editedBusinessDetails: null,
      headline1: '',
      headline2: ''
    };
  },
  created(){
    this.editedBusinessDetails = JSON.parse(
      JSON.stringify(this.businessDetails)
    );
    if(this.promoteServices){
      this.isSingleServiceSelected = this.promoteServices.length <= 1;
    }else{
      this.isSingleServiceSelected = this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.promoteServices.length === 1;
    }
    this.headline1 = this.editedBusinessDetails &&
    this.editedBusinessDetails.creativeDetail &&
    this.editedBusinessDetails.creativeDetail.adDetail &&
    this.editedBusinessDetails.creativeDetail.adDetail.textAd &&
    this.editedBusinessDetails.creativeDetail.adDetail.textAd.headline1;
    this.headline2 = this.editedBusinessDetails &&
    this.editedBusinessDetails.creativeDetail &&
    this.editedBusinessDetails.creativeDetail.adDetail &&
    this.editedBusinessDetails.creativeDetail.adDetail.textAd &&
    this.editedBusinessDetails.creativeDetail.adDetail.textAd.headline2;
  },
  methods: {
    updateDescription(description) {
      this.editedBusinessDetails.creativeDetail.adDetail.textAd[description.name] = description.value;
      this.$emit('update', this.editedBusinessDetails);
    },
    updateHeadLine1(){
      this.editedBusinessDetails.creativeDetail.adDetail.textAd.headline1 = this.headline1;
      this.$emit('update', this.editedBusinessDetails);
    },
    updateHeadLine2(value){
      this.headline2 = value;
      this.editedBusinessDetails.creativeDetail.adDetail.textAd.headline2 = this.headline2;
      this.$emit('update', this.editedBusinessDetails);
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'roimaticConfiguration', 'promoteServices', 'isInAppCampaign', 'roimaticCampaignId', 'businessProfileId']),
    service() {
      return this.businessDetails.services[0];
    },
    textAd() {
      return this.editedBusinessDetails.creativeDetail.adDetail.textAd;
    },
    isShortenFlow(){
      if(this.businessDetails && this.businessDetails.shortenFlow){
        return true;
      }
      else if(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow){
        return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep.input-title {
  line-height: 1.33;
  font-weight: 600;
  opacity: 0.56;
  font-size: 15px !important;
  letter-spacing: normal;
  color: var(--v-black-base);
}
::v-deep input {
  color: var(--v-black-base) !important;
}
::v-deep.primary-color {
    color: var(--v-primary-base) !important;
}
::v-deep.error-color {
  color: var(--v-error-base);
}

.label{
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    padding-left: 0px !important;
}
</style>